import classNames from 'classnames';

export const SliderItemSave = ({ as = 'div', className, ...props }) => {
	const SlideItem = as;
	return (
		<SlideItem
			className={classNames('splide__slide', className)}
			{...props}
		/>
	);
};

const SliderSave = ({
	className,
	children,
	init,
	mainDimension,
	autoScroll,
}) => {
	const extraOptions = {
		...(mainDimension === 'height' ? { autoWidth: true } : {}),
		...(autoScroll
			? {
					autoScroll: {
						rewind: true,
						speed: autoScroll?.speed || 1,
						pauseOnHover: false,
						pauseOnFocus: false,
					},
					autoWidth: true,
					autoplay: false,
					speed: 1000,
					type: 'loop',
					drag: 'free',
					focus: 'center',
					easing: 'linear',
			  }
			: {}),
	};
	return (
		<div
			className={classNames('ona-slider', 'splide', className)}
			{...(init ? { 'data-splide': JSON.stringify(init) } : {})}
			{...(extraOptions
				? { 'data-slider-options': JSON.stringify(extraOptions) }
				: {})}
		>
			<div className="splide__track">
				<div className="splide__list">{children}</div>
			</div>
		</div>
	);
};

export default SliderSave;
